
import "../Popover/Popover.st.css.js";
import "../Foundation/stylable/typography.st.css.js";

import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/shadows.st.css.js";
import "../Text/Text.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_220_2_Tooltip";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_220_2_Tooltip__root","content":"wds_1_220_2_Popover__content","text-small-normal":"wds_1_220_2_StylableTypography__text-small-normal","text-tiny-thin":"wds_1_220_2_StylableTypography__text-tiny-thin","text":"wds_1_220_2_Tooltip__text"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wsr-text-line-height-tiny":"--wsr-text-line-height-tiny","wsr-font-weight-regular":"--wsr-font-weight-regular","wsr-text-font-size-small":"--wsr-text-font-size-small","wsr-text-line-height-small":"--wsr-text-line-height-small","wds-tooltip-padding-vertical-medium":"--wds-tooltip-padding-vertical-medium","wds-tooltip-padding-horizontal-medium":"--wds-tooltip-padding-horizontal-medium","wds-tooltip-padding-vertical-small":"--wds-tooltip-padding-vertical-small","wds-tooltip-padding-horizontal-small":"--wds-tooltip-padding-horizontal-small","wds-tooltip-background-fill":"--wds-tooltip-background-fill","wds-tooltip-text-fill":"--wds-tooltip-text-fill","wds-tooltip-border-radius":"--wds-tooltip-border-radius","wds-tooltip-label-font-weight-medium":"--wds-tooltip-label-font-weight-medium","wds-tooltip-label-font-size-medium":"--wds-tooltip-label-font-size-medium","wds-tooltip-label-font-line-height-small":"--wds-tooltip-label-font-line-height-small","wds-tooltip-label-font-line-height-medium":"--wds-tooltip-label-font-line-height-medium","wds-shadow-surface-overlay-dark":"--wds-shadow-surface-overlay-dark","wds-font-line-height-body-tiny":"--wds-font-line-height-body-tiny","wds-font-weight-regular":"--wds-font-weight-regular","wds-font-size-body-small":"--wds-font-size-body-small","wds-font-line-height-body-small":"--wds-font-line-height-body-small"}; 




